import React from "react";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  tablePaper: {
    backgroundColor: "#FFF",
    margin: theme.spacing(4, 3, 3, 3),
  },
}));

const TablePaper = React.forwardRef((props, ref) => {
  const classes = useStyles();

  return (
    <Paper ref={ref} className={classes.tablePaper}>
      {props.children}
    </Paper>
  );
});

TablePaper.propTypes = {
  children: PropTypes.node,
};

export default TablePaper;
